var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.show ? _c('div', {
    staticClass: "base-popup-overlay",
    on: {
      "click": _vm.handleOverlayClick
    }
  }, [_c('div', {
    staticClass: "base-popup-card",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm.showCloseButton ? _c('button', {
    staticClass: "base-popup-close",
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "40",
      "height": "40",
      "viewBox": "0 0 40 40",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_292_6835)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 0C8.95437 0 0 8.95437 0 20C0 31.0462 8.95437 40 20 40C31.0462 40 40 31.0462 40 20C40 8.95437 31.0462 0 20 0ZM20 37.5394C10.3506 37.5394 2.5 29.6494 2.5 19.9999C2.5 10.3505 10.3506 2.49992 20 2.49992C29.6494 2.49992 37.5 10.3506 37.5 19.9999C37.5 29.6493 29.6494 37.5394 20 37.5394ZM27.0706 12.9294C26.5825 12.4412 25.7913 12.4412 25.3031 12.9294L20 18.2325L14.6969 12.9294C14.2087 12.4412 13.4175 12.4412 12.9288 12.9294C12.4406 13.4175 12.4406 14.2087 12.9288 14.6969L18.2319 20L12.9288 25.3031C12.4406 25.7906 12.4406 26.5832 12.9288 27.0707C13.4169 27.5588 14.2081 27.5588 14.6969 27.0707L20 21.7675L25.3031 27.0707C25.7913 27.5588 26.5825 27.5588 27.0706 27.0707C27.5588 26.5832 27.5588 25.7906 27.0706 25.3031L21.7675 20L27.0706 14.6969C27.5594 14.2081 27.5594 13.4169 27.0706 12.9294Z",
      "fill": "white"
    }
  })]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_292_6835"
    }
  }, [_c('rect', {
    attrs: {
      "width": "40",
      "height": "40",
      "fill": "white"
    }
  })])])])]) : _vm._e(), _c('div', {
    staticClass: "base-popup-content"
  }, [_vm._t("default")], 2)])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }